import dayjs from 'dayjs'

import getUploadDateByValue from 'utils/getUploadDateByValue'

export const getCustomTimeDifference = uploadDateParam => {
  const uploadDate = getUploadDateByValue(uploadDateParam)
  const difference = dayjs(uploadDate?.lte).diff(uploadDate?.gte, 'day')
  return difference
}
